import { GET_STORE } from './ApiConstants';
import api from './ApiHandler';

export const getStoreDetails = async () => {
  return await api.get(GET_STORE);
};
